import router from './router'
import { useAppStoreWithOut } from '@/store/modules/app'
import { useStorage } from '@/hooks/web/useStorage'
import type { RouteRecordRaw } from 'vue-router'
import { useTitle } from '@/hooks/web/useTitle'
import { useNProgress } from '@/hooks/web/useNProgress'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { usePageLoading } from '@/hooks/web/usePageLoading'
import { detailApi as fetchSteInfo } from '@/api/sys/config'
import { useUserStore } from '@/store/modules/user'
import { ElMessage } from 'element-plus'

const permissionStore = usePermissionStoreWithOut()

const appStore = useAppStoreWithOut()
const userStore = useUserStore()

const { getStorage } = useStorage("localStorage")

const { start, done } = useNProgress()

const { loadStart, loadDone } = usePageLoading()

const whiteList = ['/login','/shareLogin'] // 不重定向白名单

router.beforeEach(async (to, from, next) => {
  start()
  loadStart()
  // 如果是重定向到404页面的就报用户页面无权限：
  if(to.path === '/404' && to.redirectedFrom?.path!== '/404'){
        ElMessage.error('跳转页面无权限！')
        next(from)
        return
  }
  // 获取网站基本信息
  if (!appStore.getSiteInfo || !appStore.getSiteInfo.id) {
    await fetchSteInfo({}).then((res) => {
      appStore.setSiteInfo(res.data)
    })
  }

  if (userStore.getUserInfo && userStore.getUserInfo.token && !to.query.token) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (permissionStore.getIsAddRouters) {
        next()
        return
      }

      // 构建路由
      const roleRouters = getStorage('roleRouters') || []
      await permissionStore.generateRoutes(roleRouters as AppCustomRouteRecordRaw[])

      permissionStore.getAddRouters.forEach((route) => {
        router.addRoute(route as unknown as RouteRecordRaw) // 动态添加可访问路由表
      })
      const redirectPath = from.query.redirect || to.path
      const redirect = decodeURIComponent(redirectPath as string)
      const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect }
      permissionStore.setIsAddRouters(true)

      if(nextData.path === '/'){
        next({ path: '/gallery/album' })
      }else{
      next(nextData)
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
    }
  }
})

router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  done() // 结束Progress
  loadDone()
})
